import { useFacilities } from "@/hooks/useFacilities";

export const useFacility = (id: number | undefined) => {
    const { facilities, isLoading, error } = useFacilities();

    const facility = facilities?.find((facility) => facility.id === id);

    return { facility, isLoading, error };
};
